module.exports = __webpack_public_path__ + "media/assets/images/tour/6a_Tour_4-7c304fc9aa4f8fbbc48c30f3654e7310.png";